export default {
    /**
     * 黄金令箭打点
     * @param {*} ext
     * @param {*} json
     */
    goldlog(ext, json = {}) {
        const params = this.JSONParam({
            ...json,
            ...(window["chat_entry_scene"] || {}),  // 沟通入口标准化，全局统一打点参数
        });
        if (params) {
            ext += `&${params}`;
        }
        var extParam = `st_page_id=${window.pageId}&ext=${encodeURIComponent(ext)}`;
        if (window.goldlog && window.goldlog.record) {
            window.goldlog.record("/sc.ma.weblite", "CLK", extParam, "GET");
        } else {
            const q = window.goldlog_queue || (window.goldlog_queue = []);
            // 发黄金令箭
            q.push({
                action: "goldlog.record",
                arguments: ["/sc.ma.weblite", "CLK", extParam, "GET"],
            });
        }
    },
    /**
     * json转url参数
     * @param {*} json
     */
    JSONParam(json = {}) {
        return Object.keys(json)
            .map(function (key) {
                return key + "=" + json[key];
            })
            .join("&");
    },

    /**
     * 获取url参数
     */
    getUrlVars(search = '') {
        let vars = {};
        if (search) {
            search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {  // eslint-disable-line
                vars[key] = value;
            });
        }
        return vars;
    },
    /**
     * json序列化
     * @param {*} obj 
     * @returns 
     */
    serialize(obj) {
        const s = [];
        /* eslint-disable no-useless-escape */
        const rbracket = /\[\]$/;
        /* eslint-enable */

        const add = function (k, v) {
            v =
                typeof v === "function"
                    ? v()
                    : v === null
                        ? ""
                        : v === undefined
                            ? ""
                            : v;
            s[s.length] = encodeURIComponent(k) + "=" + encodeURIComponent(v);
        };
        const buildParams = function (prefix, obj) {
            let i, len, key;

            if (prefix) {
                if (Array.isArray(obj)) {
                    for (i = 0, len = obj.length; i < len; i++) {
                        if (rbracket.test(prefix)) {
                            add(prefix, obj[i]);
                        } else {
                            buildParams(
                                prefix + "[" + (typeof obj[i] === "object" ? i : "") + "]",
                                obj[i]
                            );
                        }
                    }
                } else if (obj && String(obj) === "[object Object]") {
                    for (key in obj) {
                        buildParams(prefix + "[" + key + "]", obj[key]);
                    }
                } else {
                    add(prefix, obj);
                }
            } else {
                if (obj && typeof obj === "object") {
                    for (key in obj) {
                        buildParams(key, obj[key]);
                    }
                }
            }
            return s;
        };

        return buildParams("", obj).join("&");
    }


}

